export const EXACT = 'EXACT';
export const PARTIAL = 'PARTIAL';